<template>
  <div id="statistic">
    <div class="ipub-filter-div mar-b-10">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="[12,16]">
          <ipub-col :span="2">
            <ipub-select v-model="params.journalId"
                         placeholder="Select Journal"
                         @change="changeJournal"
                         :options="journalList" />
          </ipub-col>
          <ipub-col :span="10">
            <site-search-group v-model.trim="params.search"
                               placeholder="Search for Manuscript No. / DOI"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <template v-if="showAdv">
          <ipub-row :gutter="[12,16]">
            <ipub-col class="flex"
                      :span="4">
              <span class="line-h-40 ipub-p2 fw-bd ipub-nowrap">Assigned Editor</span>
              <ipub-input class="mar-l-12"
                          style="width:100%"
                          placeholder="Search for Assigned Editor"
                          @keypress.enter.native="getList()"
                          v-model.trim="params.assignedEditor" />
            </ipub-col>
            <ipub-col class="flex"
                      :span="5">
              <span class="line-h-40 ipub-p2 fw-bd">Country</span>
              <ipub-select search
                           :clear="true"
                           @change="getList()"
                           @search="countrySearch"
                           class="mar-l-12"
                           placeholder="Select Country | Region"
                           v-model="params.countryCode">
                <ipub-select-option v-for="item in countryList"
                                    :value="item.code"
                                    :key="'countryList'+item.code">
                  {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
                </ipub-select-option>
              </ipub-select>
            </ipub-col>
            <ipub-col class="flex"
                      :span="3">
              <span class="line-h-40 ipub-p2 fw-bd">Zone</span>
              <ipub-select :clear="true"
                           class="mar-l-12"
                           @change="getList()"
                           placeholder="Select Zone"
                           v-model="params.zone">
                <ipub-select-option value="ONE">Zone I</ipub-select-option>
                <ipub-select-option value="TWO">Zone II</ipub-select-option>
                <ipub-select-option value="THREE">Zone III</ipub-select-option>
              </ipub-select>
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[12,16]">
            <ipub-col :span="6"
                      class="flex">
              <span class="line-h-40 ipub-p2 fw-bd">Section</span>
              <ipub-select placeholder="Select Section"
                           :options="sectionList"
                           :tree="true"
                           optionKey="id"
                           :clear="true"
                           @change="getList()"
                           class="mar-l-12"
                           v-model="params.sectionId" />
            </ipub-col>
            <ipub-col :span="6"
                      class="flex">
              <span class="line-h-40 nowrap ipub-p2 fw-bd">Special Issue</span>
              <ipub-select placeholder="Select Special Issue"
                           :options="specialList"
                           search
                           class="mar-l-12"
                           :clear="true"
                           @search="getSpecial"
                           @change="getList()"
                           optionTitle="titleText"
                           v-model="params.specialId" />
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="12">
            <ipub-col :span="6"
                      class="flex"
                      style="align-item:center">
              <span class="line-h-40 nowrap ipub-p2 fw-bd">Published Date</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width:100%"
                                      :placeholder="['From','To']"
                                      @change="handleDateChange"
                                      v-model="date" />
            </ipub-col>
            <ipub-col :span="6"
                      class="flex line-h-40 ipub-p2 fw-bd"
                      style="align-item:center">
              <ipub-radio-group v-model="params.free"
                                @change="getList()"
                                _label="name"
                                :options="[{name:'Free article',value:true},{name:'Paid article',value:false}]" />
            </ipub-col>
          </ipub-row>
        </template>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showAdv = !showAdv}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>
    <div>
      <!-- <div class="ipub-p1 mar-b-20">
        update time: {{$moment(staticTime).format('HH : mm DD / MM / YYYY')}}
      </div> -->
      <div class="line-h-40 mar-b-20 relative"
           v-show="user.codeList&&user.codeList.includes('STATISTICS.DATA_REPORT.ARTICLE_STATISTICS.EXPORT')"
           style="min-height:40px">
        <div class=" ipub-p1">
          <ipub-button :loading="loading"
                       type="primary"
                       @click="exp">Export</ipub-button>
        </div>
      </div>
      <ipub-table :columns="columns"
                  fixed
                  @order="onOrderChanage"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:doi="{text, record}">
          <a class="link-color"
             @click="goToWebsite(record, 'article', record.journal.name)">{{text}}</a>
        </template>
        <template v-slot:type="{text}">{{manuscriptType[text]}}</template>
        <template v-slot:country="{text}">{{text?country[text]:'--'}}</template>
        <template v-slot:special="{ text, record }">
          <ipub-tooltip v-if="text"
                        style="width:100%"
                        placement="bottomLeft">
            <div slot="title">
              {{text.titleText}}
            </div>
            <div class="omis link-color ipub-c-p"
                 @click="goToWebsite(text, 'special', record.journal.name)">
              {{text.titleText}}
            </div>
          </ipub-tooltip>
          <template v-else>--</template>
        </template>
        <template v-slot:section="{ text, record }">
          <div v-if="text&&text.length"
               style="width:100%">
            <div v-for="item in text"
                 style="width:100%"
                 class="flex"
                 :key="record.id+item.id">
              <ipub-tooltip style="width:100%"
                            placement="bottomLeft">
                <div slot="title">
                  {{item.name}}
                </div>
                <div class="omis link-color ipub-c-p"
                     @click="goToWebsite(item, 'section', record.journal.name)">
                  {{item.name}}
                </div>
              </ipub-tooltip>
            </div>
          </div>
          <template v-else>--</template>
        </template>
        <template v-slot:status="{text}">{{ARTICLE_STATUS[text]}}</template>
      </ipub-table>
    </div>
    <!-- <add-conferences ref="conferences-form"
                     :isVisable="isVisable"
                     @confirm="confirm"
                     @cancel="cancel"></add-conferences> -->
  </div>
</template>
<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
